import React, { InputHTMLAttributes } from 'react';
import styles from './GeneralTable.module.css';

type Props = InputHTMLAttributes<HTMLTableElement>;

function GeneralTable({ children }: Props) {
  return <table className={styles.generalTable}>{children}</table>;
}

export default GeneralTable;
